import { render, staticRenderFns } from "./Disabled.vue?vue&type=template&id=270a4088&scoped=true&"
import script from "./Disabled.vue?vue&type=script&lang=js&"
export * from "./Disabled.vue?vue&type=script&lang=js&"
import style0 from "./Disabled.vue?vue&type=style&index=0&id=270a4088&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "270a4088",
  null
  
)

export default component.exports